import {
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output
} from '@angular/core';

import {
    MatDialog,
    MatDialogRef,
} from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import {
    AddCampaignParticipantDialogComponent,
    IAddCampaignParticipantDialogData,
    IAddCampaignParticipantDialogReturnData
} from '../add-campaign-participant-dialog/add-campaign-participant-dialog.component';

@Component({
    selector: 'app-add-campaign-participant',
    templateUrl: './add-campaign-participant.component.html',
    styleUrls: ['./add-campaign-participant.component.scss']
})
export class AddCampaignParticipantComponent implements OnInit {
    @Output() created = new EventEmitter<IAddCampaignParticipantDialogReturnData>();
    @Input() data: IAddCampaignParticipantDialogData = {};

    constructor (
        public dialog: MatDialog,
        public route: ActivatedRoute,
    ) {
    }

    ngOnInit (): void {
    }

    openDialog (): MatDialogRef<AddCampaignParticipantDialogComponent> {
        this.data.route = this.route;

        const dialogRef = this.dialog.open(AddCampaignParticipantDialogComponent, {
            width: '556px',
            data: this.data
        });

        dialogRef.afterClosed().subscribe((result: IAddCampaignParticipantDialogReturnData) => {
            if (result?.campaignParticipant?.id) {
                this.created.emit(result);
            }
        });

        return dialogRef;
    }
}
